export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
};

export const formatDate = (value, full = false) => {
  let datetoformat = value instanceof Date ? new Date() : new Date(value);

  let jour = datetoformat.getDate();
  let mois = datetoformat.getMonth() + 1;
  let annee = datetoformat.getFullYear();
  let heure = datetoformat.getHours();
  let minutes = datetoformat.getMinutes();
  // let secondes = datetoformat.getSeconds();

  let formattedDate =
    jour.toString().padStart(2, "0") +
    "/" +
    mois.toString().padStart(2, "0") +
    "/" +
    annee;

  if (full) {
    formattedDate +=
      " à " +
      heure.toString().padStart(2, "0") +
      ":" +
      minutes.toString().padStart(2, "0");
  }

  return formattedDate;
};

export const month_label = {
  1: "Janvier",
  2: "Février",
  3: "Mars",
  4: "Avril",
  5: "Mai",
  6: "Juin",
  7: "Julliet",
  8: "Aout",
  9: "Septembre",
  10: "Octobre",
  11: "Novembre",
  12: "Décembre",
};
